import VError from 'verror';
import * as Sentry from '@sentry/browser';
import { proxyFetch, parseResponse } from '../fetch';

export const getBillingConfiguration = ({ rackspaceAccountNumber }) => {
  const url = `${process.env.REACT_APP_BILLING_API}/configuration`;
  const headers = rackspaceAccountNumber ? ({ 'X-Tenant-Id': rackspaceAccountNumber }) : {};
  return proxyFetch(url, { headers })
    .then(parseResponse)
    .catch((error) => {
      Sentry.captureException(error);
      return Promise.reject(new VError({
        name: 'RackspaceApiError',
        info: {
          code: error.code,
          message: error.message,
          error,
        },
      }, 'Failed to fetch Billing Configuration'));
    });
};

export const getSystemsAccount = ({ projectId }) => {
  const url = `${process.env.REACT_APP_CMS_API}/customer_accounts?metadataKey=mpc:systemsAccountForTenantId&metadataValue=managed_gcp:${projectId}`;
  return proxyFetch(url).then(parseResponse);
};
